import { Identifiable, TimeRecord } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function saveTimeRecord(httpClient: HttpClient) {
  return (timeRecord: TimeRecord) =>
    httpClient
      .sendHttpRequest<Identifiable<TimeRecord>>({
        endpoint: "/timesheet/timeRecord",
        method: HttpMethods.POST,
        data: {
          resource: `resources/${timeRecord.resource.uuid}`,
          task: `tasks/${timeRecord.task.uuid}`,
          timeSpent: timeRecord.timeSpent,
          date: timeRecord.date,
          month: timeRecord.month,
          year: timeRecord.year,
          ...(timeRecord.attributes && { attributes: timeRecord.attributes }),
        },
      })
      .then((nextTimeRecord) => ({
        ...nextTimeRecord,
        task: timeRecord.task,
        resource: timeRecord.resource,
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            timesheetDeadlineExceeded: "timesheetDeadlineExceeded",
          }),
        ),
      );
}

export { saveTimeRecord };
